// Messages for portal/Security (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.security.head': 'Security — Customer portal',
  'portal.security.title': 'Security',
  'portal.security.intro': 'Choose how you sign in to the portal.',
  'portal.security.on': 'On',
  'portal.security.off': 'Off',
  'portal.security.password.title': 'Password',
  'portal.security.password.desc': 'Sign in with your email and password.',
  'portal.security.magic_link.title': 'Magic link',
  'portal.security.magic_link.desc':
    'Sign in with a secure link emailed to you — no password needed.',
  'portal.security.magic_link.connected': 'Links are sent to {email} · set up {date}',
  'portal.security.magic_link.setup': 'Turn on',
  'portal.security.magic_link.disable': 'Turn off',
  'portal.security.magic_link.note':
    "When magic link is on you can sign in from the login page with a link we email you. If you use two-factor authentication, you'll still be asked for your code.",
}

export const zhTW = {
  'portal.security.head': '安全性 — 客戶入口',
  'portal.security.title': '安全性',
  'portal.security.intro': '選擇您登入客戶入口的方式。',
  'portal.security.on': '已開啟',
  'portal.security.off': '已關閉',
  'portal.security.password.title': '密碼',
  'portal.security.password.desc': '使用電子郵件與密碼登入。',
  'portal.security.magic_link.title': '魔術連結',
  'portal.security.magic_link.desc': '透過寄送到您信箱的安全連結登入，無需密碼。',
  'portal.security.magic_link.connected': '連結將寄送至 {email} · 於 {date} 設定',
  'portal.security.magic_link.setup': '開啟',
  'portal.security.magic_link.disable': '關閉',
  'portal.security.magic_link.note':
    '開啟魔術連結後，您可在登入頁面使用我們寄送的連結登入。若您已啟用雙重驗證，仍會要求輸入驗證碼。',
}
